/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { ChapterModel, ChapterModelType } from './ChapterModel'
import { ChapterModelSelector } from './ChapterModel.base'
import { TeacherModel, TeacherModelType } from './TeacherModel'
import { TeacherModelSelector } from './TeacherModel.base'
import { RootStoreType } from './index'

/**
 * LessonChapterProgressBase
 * auto generated base class for the model LessonChapterProgressModel.
 */
export const LessonChapterProgressModelBase = ModelBase.named('LessonChapterProgress')
  .props({
    __typename: types.optional(types.literal('LessonChapterProgress'), 'LessonChapterProgress'),
    chapters: types.union(types.undefined, types.array(types.late(() => ChapterModel))),
    description: types.union(types.undefined, types.string),
    duration: types.union(types.undefined, types.string),
    image: types.union(types.undefined, types.string),
    lessonId: types.union(types.undefined, types.string),
    name: types.union(types.undefined, types.string),
    skills: types.union(types.undefined, types.array(types.string)),
    teacher: types.union(
      types.undefined,
      types.late(() => TeacherModel)
    )
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class LessonChapterProgressModelSelector extends QueryBuilder {
  get description() {
    return this.__attr('description')
  }
  get duration() {
    return this.__attr('duration')
  }
  get image() {
    return this.__attr('image')
  }
  get lessonId() {
    return this.__attr('lessonId')
  }
  get name() {
    return this.__attr('name')
  }
  get skills() {
    return this.__attr('skills')
  }
  chapters(
    builder: string | ChapterModelSelector | ((selector: ChapterModelSelector) => ChapterModelSelector) | undefined
  ) {
    return this.__child('chapters', ChapterModelSelector, builder)
  }
  teacher(
    builder: string | TeacherModelSelector | ((selector: TeacherModelSelector) => TeacherModelSelector) | undefined
  ) {
    return this.__child('teacher', TeacherModelSelector, builder)
  }
}
export function selectFromLessonChapterProgress() {
  return new LessonChapterProgressModelSelector()
}

export const lessonChapterProgressModelPrimitives =
  selectFromLessonChapterProgress().description.duration.image.lessonId.name.skills
